import React from 'react'
import {Col, VertTypography} from "@vertem-core/vertice-ds";

const ProductDetailVoucher = ({ email }) => {
    return (
        <>
            <Col className="col-12">
                <VertTypography.Paragraph className="label font-w-600 padding-bottom-small">
                    E-mail de envio
                </VertTypography.Paragraph>
                <VertTypography.Paragraph className="label font-w-400 padding-bottom-extra-small">
                    O seu vale presente será enviado em até 7 dias úteis para o
                    e-mail abaixo.
                </VertTypography.Paragraph>
                <VertTypography.Paragraph className="font-w-600">
                    <strong>{email}</strong>
                </VertTypography.Paragraph>
            </Col>

            <div className="divider" />
        </>
    )
}

export default ProductDetailVoucher;
